<template>
  <div class="documentContainer">
    <h2>玄鸟外服系统使用说明</h2>
    <h3>一、登录</h3>
    <ul>
      <li>
        <label>PC端访问地址【公司员工登录】：</label>
        <a href="http://erp.xnserve.com">http://erp.xnserve.com</a>
      </li>
      <li>
        <label>移动端-微信公众号【签约登录】：</label>
        <a>玄鸟外服-->员工账号-->玄鸟平台</a>
      </li>
    </ul>
    <h3>二、更新日志</h3>
    <div>
      <p>版本号：1.2.1</p>
      <p>移动端#</p>
      <p>修复bug：已离职未签约员工，无法再次入职。</p>
      <p>PC#</p>
      <p>增加 菜单栏权限设置：依据岗位显示对应菜单权限</p>
      <p>版本号：1.2.0</p>
      <p>PC#</p>
      <p>增加 公司列表【设置->公司列表】：玄鸟公司信息，新建公司需建立部门</p>
      <p>增加 部门列表【设置->部门列表】：部门信息</p>
      <p>增加 客户公司列表【客户中心->客户公司列表】：签约客户公司</p>
      <p>增加 客户拜访【运营数据->客户拜访】：片区经理客户拜访记录</p>
      <p>增加 工作日志【运营数据->工作日志】：玄鸟内部员工工作日志</p>
      <p>增加 发送消息【首页】：向各岗位人员发送消息</p>
      <p>增加 重置密码 【账号->用户】：重置用户密码</p>
      <p>更新 统计数据【运营数据->统计数据】：片区经理对客户员工拜访统计</p>
      <p>
        更新
        内部员工【账号->内部员工】：公司内部员工账号新建，绑定入职公司部门以及关联项目
      </p>
      <p>
        更新 客户员工【账号->客户员工】：签约客户员工账号新建，绑定入职客户公司
      </p>
      <p>移动端#</p>
      <p>
        增加 客户列表：根据其绑定项目关系对应客户员工；新建客户账号；客户拜访；
      </p>
      <p>增加 统计数据：新增客户拜访统计</p>
      <p>更新 去除首页天气banner；</p>
    </div>
    <h3>三、签约认证流程说明</h3>
    <div>
      <p>1.填写入职信息开通账号</p>
      <p>2.员工移动端登录</p>
      <p>3.员工身份认证</p>
      <p>4.员工签约合同</p>
      <p>5.后台审核资料</p>
      <p>6.后台通知入职</p>
    </div>
    <h3>四、员工操作说明</h3>
    <div class="signImg">
      <viewer :images="signPic">
        <img
          class="imgStyle"
          v-for="item in signPic"
          :src="item.src"
          :key="item.src"
        />
      </viewer>
    </div>
    <h3>五、招聘人员操作流程说明</h3>
    <div>
      <p>1. 新增简历【从各大平台下载简历【58、boss、智联】</p>
      <p>
        2.上传到系统（自动任务派发给招聘人员）【新增简历：简历来源／姓名／手机号码／年龄／性别／地址／应聘岗位／招聘人员】
      </p>
      <p>3.招聘人员完成任务【编辑即完成】PC端操作</p>
      <span
        >3-1.有效：编辑、指派片区经理（派发任务）【指派片区经理姓名／意愿程度】</span
      >
      <span>3-2.无效：编辑【是否需要跟进／是否需要申诉】</span>
      <p>4.片区经理完成任务【编辑即完成】移动端操作</p>
    </div>
    <h3>六、城配物流后台操作说明</h3>
    <div>
      <p>1.设置项目结算方式与数据【项目中心-城配物流-增加】</p>
      <p>2.进入物流后台操作【项目中心-城配物流-物流系统入口】</p>
      <p>3.物流系统-配置常用项</p>
      <p>
        4.物流系统-权限设置【工单管理-配置常用项-新增】注：员工默认为系统设置常用项
      </p>
      <span>4-1.设置项目区域【用户权限[物流]-项目区域-增加】</span>
      <span>4-2.设置管理员【用户权限[物流]-管理员-增加】 </span>
      <span
        >4-3.设置客户（即甲方）公司管理员【用户权限[物流]-客户员工-增加】
        注：如无想要设置的用户，PC端在总后台账号-客户员工-新增；移动端在工作台-客户列表-新增</span
      >
      <span
        >4-4.设置员工（即司机）【用户权限[物流]-员工-设置】注：未设置区域员工默认区域为项目区域；如无想要设置员工，CRM流程新增（即操作面试-入职）。</span
      >
      <p>5.物流系统-员工信息设置</p>
      <span
        >5-1.编辑资料【用户权限[物流]-员工-编辑资料】员工资料其本人也可以进行编辑</span
      >
      <span>5-2.员工项目相关设置【用户权限[物流]-员工-设置】</span>
      <span
        >5-3.结算/常用项设置【用户权限[物流]-员工-JD／HL结算设置】
        注：默认为系统配置</span
      >
      <p>6.新增工单【管理员为员工提交工单】</p>
      <span>6-1.新增JD工单【工单管理-JD工单-新增】</span>
      <span>6-2.新增HL工单【工单管理-HL工单-新增】</span>
      <p>7.物流系统-下载数据【工单管理-下载】</p>
    </div>
    <h3>六、其他</h3>
    <div>
      <p>1.合同签署后系统需要约1-2分钟处理，方可生成。</p>
      <p>
        2.编辑用户资料时，如更改用户手机号，初始密码不会发生变化，依旧为新建时手机号的后六位。
      </p>
      <p>3.所有页面返回按钮，均为当前页面面包屑【即页面内容上方页面路径】</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      signPic: [
        {
          src: require("../../assets/sign/qm1.jpg")
        },
        {
          src: require("../../assets/sign/qm2.jpg")
        },
        {
          src: require("../../assets/sign/qm3.jpg")
        },
        {
          src: require("../../assets/sign/qm4.jpg")
        },
        {
          src: require("../../assets/sign/qm5.jpg")
        },
        {
          src: require("../../assets/sign/qm6.jpg")
        },
        {
          src: require("../../assets/sign/qm7.jpg")
        },
        {
          src: require("../../assets/sign/qm8.jpg")
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.documentContainer {
  padding-bottom: 52px;
  h2 {
    text-align: center;
    margin: 50px 0 30px;
    // font-weight: normal;
  }
  h3 {
    margin-top: 20px;
    line-height: 24px;
  }
  margin-left: 20%;
  > ul,
  > div {
    margin-left: 30px;
    li,
    p {
      margin-bottom: 6px;
      line-height: 24px;
      > p {
        //   color: #000;
        margin-left: 12px;
        line-height: 24px;
      }
    }
    span {
      display: block;
      margin-bottom: 6px;
      line-height: 24px;
      margin-left: 16px;
      max-width: 80%;
    }
  }
}
.signImg {
  img {
    height: 400px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
}
</style>
